/**
 * created by mleitzell on 3/27/18.
 */
import View from "app/core/View";
import template from "common/login/logout/ExternalLogoutView.html";
import "app/widgets/Message/Message";
import "common/managers/locale";

export default View.extend({

    init: function() {

        View.fn.init.call(this, template, {
            shouldContainerScroll: false,
            wrap: false
        });
    }
});
